import { component } from 'picoapp';
import modifyCart from 'lib/modify-cart';

export default component(async (node) => {
  const form = node.querySelector<HTMLFormElement>('[data-form]');
  const qtyInput = node.querySelector<HTMLInputElement>('[data-qty-input]');
  const qtyDecreaseBtn = node.querySelector<HTMLButtonElement>('[data-qty-decrease-btn');
  const qtyIncreaseBtn = node.querySelector<HTMLButtonElement>('[data-qty-increase-btn');
  const removeBtn = node.querySelector<HTMLButtonElement>('[data-remove-btn]');

  const setQty = (modifier: number) => {
    qtyInput.value = (parseInt(qtyInput.value, 10) + modifier).toString();

    const formData = new FormData(form);
    modifyCart('change', formData);
  };

  const initQtyBtns = () => {
    qtyDecreaseBtn.addEventListener('click', () => setQty(-1));
    qtyIncreaseBtn.addEventListener('click', () => setQty(+1));
  };

  const initRemoveBtn = () => {
    removeBtn.addEventListener('click', () => {
      setQty(parseInt(qtyInput.value, 10) * -1);
    });
  };

  const init = () => {
    initQtyBtns();
    initRemoveBtn();
  };

  init();
});
